/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityStatsSurfaceCategory } from './ControlEntityStatsSurfaceCategory';
import {
    ControlEntityStatsSurfaceCategoryFromJSON,
    ControlEntityStatsSurfaceCategoryFromJSONTyped,
    ControlEntityStatsSurfaceCategoryToJSON,
} from './ControlEntityStatsSurfaceCategory';

/**
 * 
 * @export
 * @interface Categories
 */
export interface Categories {
    /**
     * 
     * @type {string}
     * @memberof Categories
     */
    key?: string;
    /**
     * 
     * @type {number}
     * @memberof Categories
     */
    value?: number;
}

/**
 * Check if a given object implements the Categories interface.
 */
export function instanceOfCategories(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CategoriesFromJSON(json: any): Categories {
    return CategoriesFromJSONTyped(json, false);
}

export function CategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Categories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function CategoriesToJSON(value?: Categories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}

